import { render, staticRenderFns } from "./ContactMenuEntry.vue?vue&type=template&id=2db7d738&scoped=true"
import script from "./ContactMenuEntry.vue?vue&type=script&lang=js"
export * from "./ContactMenuEntry.vue?vue&type=script&lang=js"
import style0 from "./ContactMenuEntry.vue?vue&type=style&index=0&id=2db7d738&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db7d738",
  null
  
)

export default component.exports